module.exports = __webpack_public_path__ + "img/child-cry.056257c.svg";